const validateDominicanId = (dominicanId: string) => {
  if (typeof dominicanId !== 'string') {
    return false;
  }
  dominicanId = dominicanId.trim();
  const onlyDigits = /^\d+$/.test(dominicanId);
  if (!onlyDigits) {
    return false;
  }

  const lengthIsValid = dominicanId.length === 11;
  if (!lengthIsValid) {
    return false;
  }

  const exceptions = ['00000000018', '11111111123', '00100759932'];

  if (exceptions.includes(dominicanId)) {
    return true;
  }

  const firstThreeDigits = dominicanId.substr(0, 3);
  if (firstThreeDigits === '000') {
    return false;
  }

  const verifierDigit = parseInt(dominicanId.substr(10, 1));
  const multipliers = '1212121212';
  const sum = dominicanId
    .substr(0, 10)
    .split('')
    .map((digit, index) => {
      const multiplier: any = multipliers.charAt(index);
      const multipliedDigit = parseInt(digit) * multiplier;

      if (multipliedDigit < 10) {
        return multipliedDigit;
      }

      const firstDigit = parseInt(multipliedDigit / 10);
      const secondDigit = multipliedDigit % 10;
      return firstDigit + secondDigit;
    })
    .reduce((a, b) => a + b);

  const remainder = (10 - (sum % 10)) % 10;
  return remainder === verifierDigit;
};

export const DocumentValidation = (value) => {
  return validateDominicanId(value)
    ? undefined
    : 'La cédula que esta ingresando no es válido';
};


export const textWithAccentsRegex = /^[a-zA-ZÀ-ÿ\s]*$/;
export const alphanumericRegex = /^[a-zA-Z0-9]*$/;